module.exports = __webpack_public_path__ + "img/hr.4e8e6968.jpg";